import { ChangeEvent, useState } from 'react';

export const useTransactionNotes = () => {
  const [txnNote, setTxnNote] = useState<string>('');

  const handleInitValue = (currentNote?: string) => setTxnNote(currentNote ?? '');

  const removeNoteFromState = () => setTxnNote('');

  const handleChangeNotes = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 200) return;

    setTxnNote(e.target.value);
  };

  return {
    txnNote,
    handleInitValue,
    handleChangeNotes,
    removeNoteFromState
  };
};
